module.exports = __webpack_public_path__ + "img/qc.c91f1daa.png";